import { apiProvider, apiClient } from '@/services/utilities/Provider';

const getByClient = (clientId, { page = 1, pageSize = 20, search = null, sortDirection = null } = {}) => {
    const params = new URLSearchParams();
    params.set('page', String(page));
    params.set('pageSize', String(pageSize));
    if (search) params.set('search', search);
    if (sortDirection) params.set('sortDirection', sortDirection);
    return apiProvider.get(`/admin/clients/${clientId}/interactions?${params.toString()}`);
};

const getById = (id) =>
    apiProvider.get(`/admin/interactions/${id}`);

const downloadAttachment = (id, name) =>
    apiClient.get(`/admin/interactions/${id}/attachments/download/file`, { params: { name }, responseType: 'blob' });

const downloadAllAttachments = (id) =>
    apiClient.get(`/admin/interactions/${id}/attachments/download`, { responseType: 'blob' });

const InteractionService = { getByClient, getById, downloadAttachment, downloadAllAttachments };
export default InteractionService;
